import React, { useState, useEffect } from 'react';

const MessageContainer = () => {
  const [messages, setMessages] = useState([]);

  useEffect(() => {
    // Listen for custom message events
    const handleMessage = (event) => {
      if (event.detail) {
        addMessage(event.detail.message, event.detail.type);
      }
    };

    window.addEventListener('showMessage', handleMessage);
    return () => window.removeEventListener('showMessage', handleMessage);
  }, []);

  const addMessage = (message, type = 'info') => {
    const id = Date.now() + Math.random();
    setMessages(prev => [...prev, { id, message, type }]);
    
    // Auto-remove after 5 seconds
    setTimeout(() => {
      setMessages(prev => prev.filter(msg => msg.id !== id));
    }, 5000);
  };

  const removeMessage = (id) => {
    setMessages(prev => prev.filter(msg => msg.id !== id));
  };

  return (
    <div className="message-container">
      {messages.map(({ id, message, type }) => (
        <div 
          key={id}
          className={`alert alert-${type === 'success' ? 'success' : type === 'error' ? 'danger' : 'info'}`}
          role="alert"
        >
          <i className={`bi bi-${type === 'success' ? 'check-circle' : type === 'error' ? 'exclamation-triangle' : 'info-circle'} me-2`}></i>
          {message}
          <button 
            type="button" 
            className="btn-close ms-auto" 
            onClick={() => removeMessage(id)}
            aria-label="Close"
          ></button>
        </div>
      ))}
    </div>
  );
};

export default MessageContainer;
